import {
  type AbstractControl,
  type ValidationErrors,
  type ValidatorFn,
  Validators,
} from '@angular/forms';

export function trimmedMinLengthValidator(minLength: number): ValidatorFn {
  const validator = Validators.minLength(minLength);

  return (control: AbstractControl<string | null>): ValidationErrors | null => {
    const trimmedControl = {
      ...control,
      value: control.value?.trim() ?? control.value,
    } as AbstractControl<string | null>;

    return validator(trimmedControl);
  };
}
